import { useContext } from 'react';
import { Avatar, makeStyles, tokens, type AvatarProps } from '@fluentui/react-components';
import { SignInContext } from '@modules/users';
import getAvatarInitials from '@shared/helpers/getAvatarInitials';
import { SQUARE_AVATAR_LARGE_FONT_MAX_CHARACTERS } from '@shared/components/Square.constants';

const useStyles = makeStyles({
  longInitials: {
    fontSize: tokens.fontSizeBase200,
  },
  longInitialsSmall: {
    fontSize: tokens.fontSizeBase100,
  },
});

type TProps = {
  id: string;
  name: string;
  size: NonNullable<AvatarProps['size']>;
};

const ProductAvatar = ({ id, name, size }: TProps) => {
  const { organization } = useContext(SignInContext);
  const initials = getAvatarInitials(name, organization.productCardAvatarCharacterCount);
  const classes = useStyles();

  return (
    <Avatar
      initials={initials}
      size={size}
      shape="square"
      color="colorful"
      idForColor={id}
      className={
        Array.from(initials).length > SQUARE_AVATAR_LARGE_FONT_MAX_CHARACTERS
          ? size >= 32
            ? classes.longInitials
            : classes.longInitialsSmall
          : undefined
      }
      aria-hidden
    />
  );
};

export default ProductAvatar;
